module.exports = __webpack_public_path__ + "img/学术会议-5.c1379140.png";